import SearchIcon from '@mui/icons-material/Search';
import { AppInput } from 'components/app-input';
import { AppScrollbars } from 'components/app-scrollbar';
import { AppLoading } from 'components/loading';
import { useAppSelector, useTranslate } from 'hooks';
import React, { useMemo, useState } from 'react';
import { filterSmartMultiFields } from 'utils/front-filters';
import { useChatOnlineUsers } from '../../hooks';
import { selectChatConversationsList } from '../../store';
import { CustomChatDialogItem } from '../dialog-item';
import { CustomChatNoConversations } from '../no-conversatins';
import style from './index.module.scss';

interface Props {
  conversationID: string | null;
  onSelectConversation: (v: string) => void;
  isLoading: boolean;
}

export const CustomChatConversations: React.FC<Props> = ({
  conversationID,
  isLoading,
  onSelectConversation,
}) => {
  const [search, setSearch] = useState('');

  const conversationsList = useAppSelector(selectChatConversationsList);

  const { checkIsOnline } = useChatOnlineUsers();

  const filteredList = useMemo(() => {
    return conversationsList.filter(({ conversation: { appUserFirstName, appUserLastName } }) => {
      return filterSmartMultiFields([appUserFirstName, appUserLastName], search);
    });
  }, [conversationsList, search]);

  const { t } = useTranslate();

  return (
    <div className={style.wrap}>
      <div className={style.panel}>
        <AppInput
          placeholder={t('search')}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          fullWidth
          InputProps={{
            endAdornment: <SearchIcon color={'secondary'} />,
          }}
          disabled={isLoading}
        />
      </div>
      <AppScrollbars autoHeightMin="100%" autoHeightMax="100%">
        <div className={style.list}>
          {!isLoading && filteredList.length === 0 && <CustomChatNoConversations />}
          {filteredList.map(({ conversation: item, isTyping }) => {
            return (
              <CustomChatDialogItem
                key={item.appUserID}
                conversationID={item.conversationID}
                isOnline={checkIsOnline(item.appUserID)}
                id={item.conversationID}
                selected={item.conversationID === conversationID}
                fullName={[item.appUserTitleOfName, item.appUserFirstName, item.appUserLastName]
                  .filter(Boolean)
                  .join(' ')}
                lastMessage={item.lastMessage}
                isNotRead={item.notRead}
                photo={item.appUserProfilePicture}
                onClick={onSelectConversation}
                isTyping={isTyping}
              />
            );
          })}
          <AppLoading active={isLoading} background={'transparent'} />
        </div>
      </AppScrollbars>
    </div>
  );
};
